<div class="fixed flex flex-col bottom-4 left-4 w-96" [style.z-index]="999">
  <fuse-alert
    *ngFor="let alert of alerts$ | async"
    class="mb-4"
    [appearance]="'fill'"
    [dismissible]="alert.showCloseButton"
    [type]="alert.type">
    <span *ngIf="alert.type === 'error'" fuseAlertTitle> Error </span>
    <span *ngIf="alert.type === 'success'" fuseAlertTitle> Success </span>
    <span *ngIf="alert.type === 'info'" fuseAlertTitle> Info </span>
    <span fuseAlertTitle></span>
    {{ alert.message }}
  </fuse-alert>
</div>
